import React from 'react';
import { MapPin, Phone, Clock, Facebook } from 'lucide-react';

const ContactSection = () => {
  return (
    <section id="kontakt" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-12">
          <span className="text-red-500">Kontakt i Lokalizacja</span>
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div className="space-y-8">
            <div className="bg-gray-50 rounded-2xl p-8 shadow-md hover:shadow-lg transition-shadow">
              <div className="flex items-start gap-4">
                <div className="bg-red-500 text-white p-3 rounded-full">
                  <MapPin size={24} />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-2">Adres:</h3>
                  <p className="text-gray-700 text-lg">ul. Rynek 20</p>
                  <p className="text-gray-700 text-lg">86-200 Chełmno</p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 shadow-md hover:shadow-lg transition-shadow">
              <div className="flex items-start gap-4">
                <div className="bg-red-500 text-white p-3 rounded-full">
                  <Clock size={24} />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-2">Godziny otwarcia:</h3>
                  <p className="text-gray-700 text-lg">Poniedziałek - Niedziela</p>
                  <p className="text-gray-700 text-lg font-semibold">12:00 - 21:30</p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 shadow-md hover:shadow-lg transition-shadow">
              <div className="flex items-start gap-4">
                <div className="bg-red-500 text-white p-3 rounded-full">
                  <Phone size={24} />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-2">Telefon:</h3>
                  <a
                    href="tel:731089300"
                    className="text-red-500 text-2xl font-bold hover:underline"
                  >
                    731 089 300
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 shadow-md hover:shadow-lg transition-shadow">
              <div className="flex items-start gap-4">
                <div className="bg-red-500 text-white p-3 rounded-full">
                  <Facebook size={24} />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-2">Facebook:</h3>
                  <a
                    href="https://www.facebook.com/FreshChickenpl/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-red-500 text-lg font-semibold hover:underline"
                  >
                    Fresh Chicken
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="rounded-2xl overflow-hidden shadow-lg h-[600px]">
            <iframe
              title="Fresh Chicken Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2381.628665132705!2d18.4230945!3d53.3499031!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4703209d058ab113%3A0x76fe3351c70e2219!2sFresh%20Chicken%20%F0%9F%8C%AF!5e0!3m2!1spl!2spl!4v1777224017541!5m2!1spl!2spl"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
